import { useGetReferenceData } from "../hooks/dataHooks/useGetReferenceData.js";

export let LIFE_INSURANCE_MIN = {};
export let LIFE_INSURANCE_MAX = {};

export let CRITICAL_ILLNESS_MIN = {};
export let CRITICAL_ILLNESS_MAX = {};

export let PERMANENT_DISABILITY_MIN = {};
export let PERMANENT_DISABILITY_MAX = {};

//TODO: SET THESE AT LOAD TIME FROM THE GETREFDATA API
export let LIFE_COVER_MIN_AGE = 16;
export let LIFE_COVER_MAX_AGE = 65;

export let ADDITIONAL_HOLDER_MIN_AGE = 16;
export let ADDITIONAL_HOLDER_MAX_AGE = 99;

export const sharedValues = () => {
  const { data, isFetching, isLoading, isError } = useGetReferenceData();
  const { coverLimitAmountList } =
    isFetching === false && isError === false ? data : {};

  if (isFetching === true || isLoading === true) return false;

  //----------------------------------------------------------------
  // * LIFE COVER
  // * Min life cover by min age range
  LIFE_INSURANCE_MIN = coverLimitAmountList?.find(
    (x) => x.minAgeLifeCover
  ).minAgeLifeCover;

  // * Max life cover by min age range
  LIFE_INSURANCE_MAX = coverLimitAmountList?.find(
    (x) => x.maxAgeLifeCover
  ).maxAgeLifeCover;

  //----------------------------------------------------------------

  //----------------------------------------------------------------
  // * CRITICAL ILLNESS COVER
  // * Min CI cover by min age range
  CRITICAL_ILLNESS_MIN = coverLimitAmountList?.find(
    (x) => x.minAgeCICover
  ).minAgeCICover;

  // * Max CI cover by min age range
  CRITICAL_ILLNESS_MAX = coverLimitAmountList?.find(
    (x) => x.maxAgeCICover
  ).maxAgeCICover;

  //----------------------------------------------------------------

  //----------------------------------------------------------------
  // * PERMANENTLY UNABLE TO WORK COVER
  // * Min PUW cover by min age range
  PERMANENT_DISABILITY_MIN = coverLimitAmountList?.find(
    (x) => x.minAgePUWCover
  ).minAgePUWCover;

  // * Max PUW cover by min age range
  PERMANENT_DISABILITY_MAX = coverLimitAmountList?.find(
    (x) => x.maxAgePUWCover
  ).maxAgePUWCover;

  //----------------------------------------------------------------

  //* Min Age allowed
  LIFE_COVER_MIN_AGE = coverLimitAmountList?.find(
    (x) => x.smallestMinAge
  ).smallestMinAge;

  //* Max age allowed
  LIFE_COVER_MAX_AGE = coverLimitAmountList?.find(
    (x) => x.largestMaxAge
  ).largestMaxAge;

  return isFetching === false && isError === false;
};
